import React from 'react';
import Loading from 'components/pure/utils/Loading';
import CardProfileForm from './CardProfileForm';
import noop from 'lodash/noop';
import alert from 'utils/alert';
import confirm from 'utils/confirm';
import EditCardProfilePageHelp from './EditCardProfilePageHelp';
import {browserHistory} from 'react-router';
import Breadcrumbs from 'components/pure/utils/Breadcrumbs';

const alreadyExists = 'A scorecard profile with this name already exists.';
const overwriteWarning = `${alreadyExists}  Do you want to overwrite it?`;

export default class EditCardProfilePage extends React.PureComponent {
  onAddSelectedScorecard = () => {
    const scorecard = this.props.EditCardProfileStore.scorecardToAdd;
    // This code is a hack.  If they add an existing scorecard, clone
    // that scorecard (which then gets added to the profile).
    // Once this ticket gets finished, this can be fixed:
    // https://execvision.myjetbrains.com/youtrack/issue/EV-8413
    this.props.AdminScorecardActions.createScorecard(
      scorecard.set('id', null).set(
        'questions',
        scorecard.questions.map(question => question.set('id', null))
      )
    );
  };

  onSave = async () => {
    const {department} = this.props.DepartmentFormStore;
    const {cardProfile} = this.props.EditCardProfileStore;
    const action = cardProfile.id === null ? 'create' : 'update';
    const sendRequest = shouldOverwrite =>
      this.props.CardProfileActions[action](cardProfile, shouldOverwrite).then(cardProfile => {
        if (this.props.addToDepartment) {
          this.props.DepartmentActions.updateDepartment(
            department.set('cardsProfileId', cardProfile.id)
          );
        }
      });
    try {
      await sendRequest(false);
    } catch (e) {
      if (e.response.status === 409) {
        if (!cardProfile.id) {
          confirm(overwriteWarning).then(() => sendRequest(true), noop);
        } else {
          alert(alreadyExists);
        }
      }
    }
  };

  render() {
    const {
      cardProfile,
      isLoading,
      isSaving,
      wasErrorFetching,
      wasErrorSaving,
      showScorecardDialog,
    } = this.props.EditCardProfileStore;
    const {EditCardProfileActions} = this.props;
    const {hasDepartmentContext, departmentId} = this.props;
    const currentUser = this.props.AuthStore.user;
    const breadcrumbLinks = [
      {
        name: 'Scorecard Profiles',
        url:
          '/admin' + (hasDepartmentContext ? `/departments/${departmentId}` : '') + '/cardProfiles',
      },
    ];

    return (
      <div className="edit-filter-words-profile-page">
        <Breadcrumbs links={breadcrumbLinks} />
        {wasErrorFetching ? (
          'Error fetching profile.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <div>
            <h1>{'Scorecard Profile - ' + (cardProfile && cardProfile.id ? 'Edit' : 'Create')}</h1>
            <EditCardProfilePageHelp cardProfile={cardProfile} />
            {wasErrorSaving && <div className="ev-error-message">Error saving profile.</div>}
            <CardProfileForm
              profile={cardProfile}
              allScorecards={this.props.ScorecardStore.scorecards}
              isSaving={isSaving}
              CardReasonStore={this.props.CardReasonStore}
              CardReasonActions={this.props.CardReasonActions}
              EditScorecardStore={this.props.EditScorecardStore}
              EditScorecardActions={this.props.EditScorecardActions}
              AdminScorecardActions={this.props.AdminScorecardActions}
              showScorecardDialog={showScorecardDialog}
              onChange={EditCardProfileActions.updateForm}
              onToggleScorecardDialog={EditCardProfileActions.toggleScorecardDialog}
              onCancel={browserHistory.goBack}
              onSelectScorecardToAdd={EditCardProfileActions.selectScorecardToAdd}
              scorecardToAdd={this.props.EditCardProfileStore.scorecardToAdd}
              onAddSelectedScorecard={this.onAddSelectedScorecard}
              CardReasonEditStore={this.props.CardReasonEditStore}
              CardReasonEditActions={this.props.CardReasonEditActions}
              onSave={this.onSave}
              currentUser={currentUser}
            />
          </div>
        )}
      </div>
    );
  }
}
